import { render, staticRenderFns } from "./QuarantineLevelCard.vue?vue&type=template&id=18e5bc62"
import script from "./QuarantineLevelCard.vue?vue&type=script&lang=js"
export * from "./QuarantineLevelCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports